import * as React from "react";
import { cn } from "@/lib/utils";
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
    return (<textarea data-slot="textarea" className={cn("placeholder:text-neutral-text-500 aria-invalid:ring-state-negative flex field-sizing-content min-h-16 w-full rounded-m bg-neutral-background-100 px-3 pt-3 pb-8 text-body1 transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50",
        "hover:ring hover:ring-neutral-text-400",
        "focus-visible:border-primary-500 focus-visible:ring-primary-500 focus-visible:ring-[1px]",
        className)} {...props} />);
}
export { Textarea };
